
export const environment = {
  production: true,
  hostDev:'https://apiunify.academia.cl',
  token:'H1mdr934.VwicbznlksLh808o9AcVnd9wbaqFKXSg'
};
